export default function RoundedButton({ text, onClick }) {
  return (
    <button
      onClick={onClick}
      className=" bg-customOrange py-2 px-5 rounded-md text-white"
    >
      {text}
    </button>
  );
}
